import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DocumentTemplateForm, DocumentTemplateFormValues } from "./DocumentTemplateForm";
import { documentTemplatesApi } from "api";
import { routes } from "consts";
import { getApiErrorMessage, useToaster } from "utils";
import { useDocumentTemplate, useDocumentType } from "api/hooks";
import { PaziaLoader } from "components/atoms";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { DocumentTypeForm } from "./DocumentTypeForm";
import { DocumentTypeModel, documentTypesApi } from "api/documentTypesApi";

export const EditDocumentTypePage = (): JSX.Element | null => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();
  const { documentTypeId } = useParams();
  const { data, loading } = useDocumentType(Number(documentTypeId));

  const onSubmit = async (data: DocumentTypeModel) => {
    try {
      await documentTypesApi.update(Number(documentTypeId), data);
      navigate(routes.DOCUMENT_TYPES);
      showSuccess(`Zaktualizowano typ dokumentu`);
    } catch (e) {
      showError(getApiErrorMessage(e, "Nie udało się zaktualizować typu dokumentu"));
      console.error(e);
    }
  };

  if (loading) return <PaziaLoader position="center" />;
  if (!data) return null;

  const breadcrumbs = [
    { title: "Szablony dokumentów", path: routes.DOCUMENTS },
    { title: "Typy dokumentów", path: routes.DOCUMENT_TYPES },
    { title: data.name },
  ];
  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Edytuj typ dokumentu" />
      <DocumentTypeForm onSubmit={onSubmit} documentType={data} />
    </PageMain>
  );
};
